<template>
  <v-container>
    <v-dialog v-model="dialog" persistent scrollable max-width="800px">
      <v-card v-if="dadosPagamento">
        <v-card-title class="pa-0">
            <v-col class="text-end px-0 py-0">
              <v-btn icon dark @click="close(false)">
                <v-icon color="primary">mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-center pt-0 pb-3" cols="12">
              <h1>Confirma quitação do pagamento?</h1>
              <!-- <p class="mb-0"> Guia Reduzida</p> -->
            </v-col>
        </v-card-title>
        <v-card-text>
          <v-row class="ma-0">
             <v-col class="text-left pb-4 pt-0" cols="4">
              <span class="card-title-form-quitapgtodialog py-0">Operadora: </span>
              <span style="font-size: 1.1rem">{{
                dadosPagamento.oper_nome
              }}</span>
            </v-col>

            <v-col class="text-left pb-4 pt-0" cols="4">
              <span class="card-title-form-quitapgtodialog py-0">Prestador: </span>
              <span style="font-size: 1.1rem">{{
                dadosPagamento.prest_nome
              }}</span>
            </v-col>
            <v-col class="text-right pb-4 pt-0" cols="4">
              <span class="card-title-form-quitapgtodialog py-0"
                >Data do pagamento:
              </span>
              <span style="font-size: 1.1rem">{{
                dadosPagamento.data_pagamento | formatDate
              }}</span>
            </v-col>
          </v-row>
          <v-form ref="dadosQuitacaoForm">
            <v-row class="ma-0">
              <v-col class="px-2 py-2" cols="3">
                <label>Valor líquido</label>
                <v-text-field
                  v-model="valor_pago_liquido"
                  @input="valor_pago_liquido = formatPrice(valor_pago_liquido);enableDisableQuitar()"
                  maxlength="16"
                  :rules="[formRules.typeNumber]"
                  outlined
                  dense
                  :disabled="!isPermissaoQuitacao"
                ></v-text-field>
              </v-col>
              <v-col class="px-2 py-2" cols="3">
                <label>Imposto pago</label>
                <v-text-field
                  v-model="valor_imposto"
                  @input="valor_imposto = formatPrice(valor_imposto);enableDisableQuitar()"
                  maxlength="16"
                  :rules="[formRules.typeNumber]"
                  outlined
                  dense
                  :disabled="!isPermissaoQuitacao"
                ></v-text-field>
              </v-col>
              <v-col class="px-2 py-2" cols="3">
                <label>Desconto aplicado</label>
                <v-text-field
                  v-model="valor_desconto"
                  @input="valor_desconto = formatPrice(valor_desconto);enableDisableQuitar()"
                  maxlength="16"
                  :rules="[formRules.typeNumber]"
                  outlined
                  dense
                  @change="enableDisableQuitar"
                  :disabled="!isPermissaoQuitacao"
                ></v-text-field>
              </v-col>
              <v-col class="px-2 py-2" cols="3">
                <label style="margin-bottom: 2px">Data do crédito</label>
                <v-menu
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateFormatted"
                      dense
                      v-mask="'##/##/####'"
                      format="DD/MM/YYYY"
                      placeholder="DD/MM/YYYY"
                      label
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar-blank"
                      @blur="formData.data_credito = parseDate(dateFormatted);enableDisableQuitar()"
                      :rules="[formRules.typeDateFormated]"
                    ></v-text-field>
                      <!-- :rules="formRules.required" -->
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="formData.data_credito"
                    @input="dateFormatted = formatDate(formData.data_credito);enableDisableQuitar()"
                    no-title
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-8">
          <v-btn outlined color="primary" height="30px" small depressed @click="close()">
           Cancelar
          </v-btn>
           <v-spacer></v-spacer>
           <v-btn color="error" height="30px" small depressed @click="excluirQuitacaoConfirm()" :disabled="!isPermissaoQuitacao || !disableQuitar">
           Excluir quitação do pagamento
          </v-btn>
          <v-btn color="primary" height="30px" small depressed @click="validate()" :disabled="!isPermissaoQuitacao || disableQuitar">
           {{dadosPagamento.quitado? 'Atualizar dados' : 'Quitar pagamento'}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      disableQuitar: true,
      dateFormatted: null,
      valor_pago_liquido: null,
      valor_imposto: null,
      valor_desconto: null,
      formData: {
        id: null,
        quitado: true,
        pagamento_publicado_id: null,
        valor_pago_liquido: null,
        valor_imposto: null,
        valor_desconto: null,
        data_credito: null,
        acao: 'IU'
      },
      formrules: null,
    };
  },
  computed: {
    ...mapState({
      permissaoAcao: state => state.userData.userData.PermissaoAcoes
    }),
  },
  watch:{
    dialog: {
      deep: true,
      handler(val){
        if(val) {
          this.formData.pagamento_publicado_id = val? this.dadosPagamento.id : null
          this.formData.quitado = val? this.dadosPagamento.quitado : null
          this.disableQuitar = this.dadosPagamento.quitado ?  true : false
          this.formData.data_credito = this.dadosPagamento.data_credito? this.dadosPagamento.data_credito : null
          this.valor_pago_liquido = this.dadosPagamento.valor_pago_liquido? this.formatPrice(this.dadosPagamento.valor_pago_liquido*100) : null
          this.valor_imposto = this.dadosPagamento.valor_imposto? this.formatPrice(this.dadosPagamento.valor_imposto*100) : null
          this.valor_desconto = this.dadosPagamento.valor_desconto? this.formatPrice(this.dadosPagamento.valor_desconto*100) : null
          this.dateFormatted = this.formatDate(this.formData.data_credito)
        } else {
          this.valor_pago_liquido = null
          this.valor_imposto = null
          this.valor_desconto = null
          this.dateFormatted = null
        }
      }
    },
    valor_pago_liquido: {
      deep: true,
      handler(val){
        this.$store.dispatch('common/parsePrice', val).then(resp=> this.formData.valor_pago_liquido = resp)
      }
    },
    valor_imposto: {
      deep: true,
      handler(val){
        this.$store.dispatch('common/parsePrice', val).then(resp=> this.formData.valor_imposto = resp)
      }
    },
    valor_desconto: {
      deep: true,
      handler(val){
        this.$store.dispatch('common/parsePrice', val).then(resp=> this.formData.valor_desconto = resp)
      }
    },
    dateFormatted(val) {
      this.formData.data_credito = this.parseDate(val);
    }
  },
  created() {
    this.formRules = this.$store.state.formRules
  },
  methods: {
    enableDisableQuitar(){
      if(!this.dadosPagamento.quitado){
        this.disableQuitar = false
      } else if (
        ((this.formData.valor_pago_liquido==0 || this.formData.valor_pago_liquido==null) && this.formData.valor_pago_liquido==this.dadosPagamento.valor_pago_liquido) 
        && ((this.formData.valor_imposto==0 || this.formData.valor_imposto==null) &&  this.formData.valor_imposto==this.dadosPagamento.valor_imposto) 
        && ((this.formData.valor_desconto==0 || this.formData.valor_desconto==null) &&  this.formData.valor_desconto==this.dadosPagamento.valor_desconto)  
      ){
          this.disableQuitar = true
      } else {
          this.disableQuitar = false
      }
    },
    excluirQuitacaoConfirm(){
      let formdata = this.formData
      let desfazerConfirm = this.excluirQuitacaoConfirm
      let mensagem = `Os dados da quitação do pagamento serão excluídos. <br>
                      Você não poderá desfazer esta ação.
                      Será possível quitar o pagamento novamente se desejar.`
      let paramModal = {
        type: "warning",
        title: "Deseja desfazer as alterações?",
        message: mensagem,
        messageForm: (text) => {
            if(text.toUpperCase()!="APAGAR")
            {
              let paramModal2 = {
                type: "warning",
                title: "Atenção!",
                message: "Necessário digitar APAGAR para excluir as quitação.",
                btConfirm: { name: "Ok", show: true},
                callback: () => setTimeout(()=>{desfazerConfirm(formdata)}, 100)
              }
              this.$store.commit("confirmMessage/showConfirmMessage", paramModal2)
            } else {
              this.excluirQuitacao(formdata)
              console.log("this.excluirQuitacao(formdata)")
            }
          },
        textForm: { label: "", title: "Confirme digitando APAGAR",  show: true },
        btConfirm: { name: "Confirmar", show: true, color:"warning" },
        btCancel: { name: 'Cancelar', show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
    },
    excluirQuitacao(formdata){
      this.formData = {
        id: formdata.id,
        pagamento_publicado_id: formdata.pagamento_publicado_id,
        valor_pago_liquido: 0,
        valor_imposto: 0,
        valor_desconto: 0,
        data_credito: null,
        acao: 'D'
      }
      this.saveForm(this.formData);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatPrice(valor) {
      let valorFormatado = valor.toString().replace(/(!\d|\.|,)/g, '')
      valorFormatado = valorFormatado.toString().replace(/\B(?=(\d{2})(?!\d))/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      return valorFormatado
    },
    validate(){
      this.formData.acao = "IU"
      if(this.$refs.dadosQuitacaoForm.validate()){
        this.saveForm(this.formData)
      }
    },
    isPermissaoQuitacao(){
      //verifica se o usuário em questão tem ação a esse endpoint e libera a ação.
      this.permissaoAcao.recebiveis.includes("savedadosquitacao");
    }
  },
  props: {
    close: Function,
    dadosPagamento: Object,
    dialog: Boolean,
    saveForm: Function,
  },
};
</script>

<style>
.texts {
  color: #4a4a4a;
  font-size: 14px;
  line-height: 23px;
}
.card-title-form-quitapgtodialog {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;
  display: block;
}
</style>